export const Projects = [
  {
    thumbnail:
      "https://s2.glbimg.com/im_lQF2n6bZkzQFp3PM-SE-HHKw=/0x0:1920x1080/984x0/smart/filters:strip_icc()/i.s3.glbimg.com/v1/AUTH_08fbf48bc0524877943fe86e43087e7a/internal_photos/bs/2019/e/F/tlaQIWTRyKBPzDoqCoeQ/portuguese-brazil.jpg",
    title: "Clone da Netflix com Bootstrap",
    tags: ["React", "CSS", "Bootstrap"],
    paragraph:
      "Clone do site de streaming Netflix feito com framework Bootstrap.",
    codelink: "https://github.com/Danyel-GranzottiUFC/clone-netflix-bootstrap",
    projectlink: "https://clone-netflix-with-bootstrap.netlify.app/",
    projectlinkText: "Clone Bootstrap",
  },
  {
    thumbnail: "/images/thumbnail/pokedex.png",
    title: "Pokedex",
    tags: ["React", "Styled Components"],
    paragraph:
      "Pokedex feita com React e Styled Components, consumindo a API PokeAPI.",
    codelink: "https://github.com/DanyelGranzotti/Pokedex",
    projectlink: "https://pokedex-danyel-granzotti.netlify.app/",
    projectlinkText: "Pokedex",
  },
  {
    thumbnail: "/images/thumbnail/great.png",
    title: "Great-Users",
    tags: ["React", "Styled Components", "Spring Boot"],
    paragraph:
      "Projeto de um CRUD front e back-end, feito com React e Spring Boot.",
    codelink: "https://github.com/DanyelGranzotti/great_users_front",
    projectlink: "https://great-user.netlify.app/",
    projectlinkText: "Great-Users",
  },
];
